export const contactsData = {
  email: "virinchi.msk83@gmail.com",
  phone: "+91-8143242514",
  address: "Bangalore, India",
  sheetAPI: "",
};
